import React, { forwardRef, useState } from "react";
import cn from "classnames";
import { Eye, EyeOff } from "lucide-react";

import { Label } from "./label";

const Input = forwardRef(
  ({ className, type = "text", children, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </input>
    );
  }
);

Input.displayName = "Input";

export default Input;

export const ThemedInput = (
  {
    label,
    placeholder,
    value,
    onChange,
    className,
    type = "text",
    children,
    error,
    ...props
  },
  ref
) => {
  return (
    <div className="flex flex-col gap-3">
      <label className="block text-sm font-medium text-neutralStrongBlack mb-1 font-semibold">
        {label}
      </label>
      <Input
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-neutralPale rounded-lg outline-none"
        value={value}
        onChange={onChange}
        {...props}
      >
        {children}
      </Input>
      {error && <p className="text-sm text-negative">{error}</p>}
    </div>
  );
};

export const PasswordInput = ({
  label = "Contraseña",
  className,
  error,
  id,
  register,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={className}>
      <Label htmlFor={id}>{label}</Label>
      <div className="relative">
        <Input
          {...register}
          type={showPassword ? "text" : "password"}
          className={cn(
            `w-full px-3 py-2 border border-neutralPale rounded-lg ${
              error ? "border-negative" : ""
            }`,
            className
          )}
          {...props}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          {showPassword ? (
            <EyeOff className="h-5 w-5" />
          ) : (
            <Eye className="h-5 w-5" />
          )}
        </button>
      </div>
      <div className="h-5">
        {error && (
          <span className="text-sm text-negative">{error.message}</span>
        )}
      </div>
    </div>
  );
};
